import { login, logout, getUserPower } from "@/api/user";
import {
  getToken,
  setToken,
  removeToken,
  getUserInfo,
  setUserInfo,
  removeUserInfo
} from "@/utils/auth";

function setRoles(userInfo) {
  let roles = [];
  if (userInfo.user_type == 2 && userInfo.parent_type == 1) {
    roles.push("admin");
  }
  return roles;
}

const state = {
  token: getToken(),
  user_info: getUserInfo()
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USER_INFO: (state, user_info) => {
    state.user_info = user_info;
  }
};

const actions = {
  // user login
  login({ commit, dispatch }, loginForm) {
    return new Promise((resolve, reject) => {
      login(loginForm)
        .then(response => {
          const { data } = response;
          let user_info = {
            ...data.userInfo,
            power: {},
            roles: setRoles(data.userInfo),
            type: loginForm.type
          };
          commit("SET_TOKEN", data.token);
          commit("SET_USER_INFO", user_info);
          setToken(data.token, loginForm.is_code === 1);
          setUserInfo(user_info);
          dispatch("getUserPowerFun");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit("SET_TOKEN", "");
          dispatch("permission/setMenuRoutes", [], { root: true });
          removeToken();
          removeUserInfo();
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit, dispatch }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      dispatch("permission/setMenuRoutes", [], { root: true });
      removeToken();
      removeUserInfo();
      resolve();
    });
  },

  getUserPowerFun({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserPower()
        .then(response => {
          const { data } = response;
          let user_info = { ...state.user_info, power: data };
          commit("SET_USER_INFO", user_info);
          setUserInfo(user_info);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
